import React, { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';

import { orderBy } from 'lodash-es';

import classNames from '../../helpers/classNames';
import useTranslate from '../../hooks/useTranslate';
import Button from '../Button/Button';
import LazyImg from '../LazyImg/LazyImg';
import Text from '../Text/Text';
import styles from './TourDestinationList.module.scss';

type TourDestinationListItem = {
  id: number;
  url: string;
  imageUrl: string;
  logoUrl: string;
  name: string;
  district: string;
  description: string;
};

export interface TourDestinationListProps {
  items: Array<TourDestinationListItem>;
}

const TourDestinationList: FC<TourDestinationListProps> = props => {
  const { items } = props;
  const { translate } = useTranslate();
  const sortedItems = useMemo(() => orderBy(items, ['name'], ['asc']), [items]);

  return (
    <Row>
      {sortedItems.map(({ id, url, name, imageUrl, logoUrl, district, description }) => (
        <Col
          key={id}
          xs={12}
          lg={6}
          className={classNames('d-flex align-items-stretch text-black mb-4', styles.container)}
          tag={Link}
          to={url}
        >
          <Card className="my-sx-4 my-lg-0 h-100 w-100">
            <div className="overflow-hidden" style={{ height: '350px' }}>
              <LazyImg
                alt={name}
                src={imageUrl}
                width="100%"
                height="100%"
                className={styles.image}
              />
            </div>
            <CardBody className="d-flex flex-column justify-content-between">
              <div className="d-flex gap-3 align-items-center flex-grow-1">
                <LazyImg src={logoUrl} alt={name} width="80px" style={{ objectFit: 'cover' }} />
                <div>
                  <div className="h4 fw-bold mb-0">{name}</div>
                  <div className="fst-italic">{district}</div>
                </div>
              </div>
              <div>
                <div className="py-2">
                  <Text clamp={4} style={{ lineHeight: '1.5em', minHeight: '6em' }}>
                    {description}
                  </Text>
                </div>

                <div className="text-end">
                  <Button primary>{translate('destinations.read-more-cta')}</Button>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default TourDestinationList;
